import { render, staticRenderFns } from "./MensalidadeFormaPagamento.vue?vue&type=template&id=6fb2be8a&scoped=true"
import script from "./MensalidadeFormaPagamento.vue?vue&type=script&lang=js"
export * from "./MensalidadeFormaPagamento.vue?vue&type=script&lang=js"
import style0 from "./MensalidadeFormaPagamento.vue?vue&type=style&index=0&id=6fb2be8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb2be8a",
  null
  
)

export default component.exports